import type { Turn } from './chatReducer';
import type { RecordRef } from './types';

/** The longest message the input accepts. */
export const MAX_MESSAGE_LENGTH = 4000;

/**
 * The record a conversation is about: the one its latest record-bound turn was
 * asked on. null while every turn so far was a general question.
 */
export function conversationRecordId(turns: readonly Turn[]): string | null {
  return conversationRecord(turns)?.id ?? null;
}

function conversationRecord(turns: readonly Turn[]): RecordRef | null {
  for (let i = turns.length - 1; i >= 0; i -= 1) {
    const ref = turns[i].recordRef;
    if (ref?.id) return ref;
  }
  return null;
}

/**
 * True when the record on screen is a different record from the one this
 * conversation is about. The server keeps one session's history and facts
 * together, so a session must never span two clients' records: the caller then
 * drops the sessionId and the turns. Moving to a page with no record, or
 * opening a first record after general questions, keeps the conversation.
 */
export function shouldStartNewChat(
  turns: readonly Turn[],
  recordRef: RecordRef | null,
): boolean {
  if (!recordRef) return false;
  const bound = conversationRecord(turns);
  return (
    bound !== null &&
    (bound.type !== recordRef.type || bound.id !== recordRef.id)
  );
}
